/**
* @author 阿佑[ayooooo@petalmail.com]
* @date 2022/4/19 20:47
* @description
*   TheSymbolCollection.vue of WeTrade
*/
<template>
<div class="fill">
  <div class="px-16 py-10 f-sm f-medium">
    <a
      v-for="(tab, index) in tabs" :key="tab.value"
      class="toggle__line-btn mr-4 p-4" :class="{active: active === index}" @click="change(index)"
    >
      <t :path="tab.label">{{tab.labelDefault}}</t>
    </a>
  </div>
  <TheMarketList :list="items" />
</div>
</template>

<script lang="ts">
import TheMarketList from '@/modules/market/components/TheMarketList.vue'
import { useMarket } from '@/modules/market/market'
import { MarketItem } from '@/modules/market/market.api'
import { computed, defineComponent, shallowRef, watchEffect } from 'vue'

export default defineComponent({
  name: 'TheSymbolCollection',
  components: { TheMarketList },
  props: {},
  setup () {
    const { tabs, index, switchTab } = useMarket()
    const read = computed(() => tabs.value[index.value].load)
    const items = shallowRef<MarketItem[]>([])

    watchEffect(() => {
      tabs.value[index.value].load().then(resp => {
        items.value = resp
      })
    })

    return {
      tabs,
      read,
      active: index,
      items,
      change: switchTab,
    }
  },
})
</script>

<style scoped>
</style>
